var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-white w-100 btn-back btn_medium w-100 mr-1",attrs:{"depressed":"","small":"","height":"32"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Cancel ")])}
var staticRenderFns = []

export { render, staticRenderFns }